import { createContext } from "react";

export const TareaContext = createContext();